const svgModules = import.meta.glob<string>('../../assets/icons/filetypes/*.svg', {
  query: '?url',
  import: 'default',
  eager: true,
});

const iconUrlMap: Record<string, string> = {};
for (const [path, url] of Object.entries(svgModules)) {
  const name = path.split('/').pop()?.replace('.svg', '');
  if (name) iconUrlMap[name] = url;
}

/**
 * Returns an `<img>` element for the given file-type extension key
 * (as returned by `fileTypeIconFor`).
 */
export function fileTypeImg(ext: string, size = 20): HTMLImageElement {
  const img = document.createElement('img');
  img.src = iconUrlMap[ext] ?? iconUrlMap['blank'] ?? '';
  img.width = size;
  img.height = size;
  img.alt = '';
  img.setAttribute('aria-hidden', 'true');
  img.className = 'file-type-icon';
  img.draggable = false;
  return img;
}
